<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
    <div
      class="relative w-full max-w-sm mx-4 rounded-2xl overflow-hidden p-8 text-center"
      style="background: #0D0F14; border: 1px solid #1E2733;"
    >
      <h2 class="text-2xl font-bold text-white mb-2">{{ $t('play.matchmaking.party_invite') }}</h2>
      <i18n-t scope="global" keypath="play.matchmaking.invited_to_party" tag="p" class="text-sm text-gray-400 mb-6">
        <template #name><span class="text-white font-medium">{{ inviterName }}</span></template>
      </i18n-t>

      <div class="flex gap-3">
        <button
          @click="respond('decline')"
          :disabled="responding"
          class="flex-1 px-4 py-3 rounded-xl bg-gray-800 text-text-primary text-base font-semibold hover:bg-gray-700 transition-colors disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
        >
          {{ $t('play.matchmaking.decline') }}
        </button>
        <button
          @click="respond('accept')"
          :disabled="responding"
          class="flex-1 px-4 py-3 rounded-xl bg-primary-600 text-white text-base font-semibold shadow-[0_0_24px_rgba(78,84,200,0.35)] hover:bg-primary-500 transition-colors disabled:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300"
        >
          {{ responding ? $t('play.matchmaking.joining') : $t('play.matchmaking.accept') }}
        </button>
      </div>

      <p v-if="error" class="text-red-400 text-xs mt-3">{{ error }}</p>
    </div>
  </div>
</template>

<script setup>
import usePartyInvite from '../../composables/usePartyInvite';

const props = defineProps({
  invite: { type: Object, required: true },
});

const {
  responding, error, inviterName, respond,
} = usePartyInvite(props);
</script>
